"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownList = _interopRequireDefault(require("./DropdownList"));

var _index = _interopRequireDefault(require("./index"));

var DropdownControl = function DropdownControl(_ref) {
  var type = _ref.type,
      align = _ref.align,
      trigger = _ref.trigger,
      items = _ref.items,
      displayListUpwards = _ref.displayListUpwards,
      hasSearch = _ref.hasSearch,
      triggerClass = _ref.triggerClass,
      disabled = _ref.disabled,
      newStyle = _ref.newStyle,
      className = _ref.className,
      closeOnDropdownClick = _ref.closeOnDropdownClick,
      searchPlaceholderText = _ref.searchPlaceholderText,
      searchIconWidth = _ref.searchIconWidth,
      searchIconHeight = _ref.searchIconHeight,
      fullWidth = _ref.fullWidth,
      onTriggerClicked = _ref.onTriggerClicked,
      _ref$customItem = _ref.customItem,
      customItem = _ref$customItem === void 0 ? null : _ref$customItem,
      _ref$customView = _ref.customView,
      customView = _ref$customView === void 0 ? null : _ref$customView,
      onCloseCallback = _ref.onCloseCallback,
      hideEmptyGroup = _ref.hideEmptyGroup;
  var content;

  if (customView) {
    content = customView;
  } else if (onTriggerClicked) {
    content = onTriggerClicked;
  } else {
    content = (0, _preact.h)(_DropdownList.default, {
      displayListUpwards: displayListUpwards,
      type: type,
      align: align,
      items: items,
      hasSearch: hasSearch !== null && hasSearch !== void 0 ? hasSearch : false,
      searchPlaceholderText: searchPlaceholderText,
      searchIconWidth: searchIconWidth,
      searchIconHeight: searchIconHeight,
      customItem: customItem,
      hideEmptyGroup: hideEmptyGroup
    });
  }

  return (0, _preact.h)(_index.default, {
    closeOnDropdownClick: closeOnDropdownClick !== null && closeOnDropdownClick !== void 0 ? closeOnDropdownClick : false,
    popupName: "control-dropdown",
    class: (0, _classnames.default)(className, 'control-dropdown', {
      'control-dropdown--brand': newStyle
    }),
    trigger: trigger,
    triggerClass: (0, _classnames.default)(triggerClass, {
      'control-dropdown--full-width': fullWidth
    }),
    disabled: disabled,
    onCloseCallback: onCloseCallback
  }, content);
};

var _default = DropdownControl;
exports.default = _default;